import {
  applyDedicatedBoldToggleToFontFamily,
  isBoldFromFontFamily,
  isDedicatedBoldFaceFamily,
  isDedicatedBoldRegularFamily,
  resolveFontStack,
  usesDedicatedFontFileForWeight,
} from './appFonts';

/** Resolve stored font-family tokens to CSS font-family stacks. */
export function resolveFontFamily(ff?: string): string | undefined {
  return resolveFontStack(ff);
}

export function hasFontFamilyValue(value: unknown): boolean {
  return typeof value === 'string' && value.trim() !== '';
}

export function isVagRegularFamily(ff: unknown): boolean {
  return isDedicatedBoldRegularFamily(ff) && normalizeVagOnly(ff);
}

export function isVagBoldFamily(ff: unknown): boolean {
  return isDedicatedBoldFaceFamily(ff) && normalizeVagOnly(ff);
}

export function isVagFamily(ff: unknown): boolean {
  return isVagRegularFamily(ff) || isVagBoldFamily(ff);
}

function normalizeVagOnly(ff: unknown): boolean {
  const key = typeof ff === 'string' ? ff.trim().toLowerCase() : '';
  return key.startsWith('vag');
}

export { isBoldFromFontFamily, usesDedicatedFontFileForWeight as isDedicatedWeightFontFamily };

/** @deprecated Use applyDedicatedBoldToggleToFontFamily */
export function applyVagBoldToggleToFontFamily(
  currentFontFamily: unknown,
  boldOn: boolean,
): { fontFamily: string; handled: true } | { handled: false } {
  return applyDedicatedBoldToggleToFontFamily(currentFontFamily, boldOn);
}

export { applyDedicatedBoldToggleToFontFamily };
